import { PayloadAction, createReducer } from '@reduxjs/toolkit';
import { FieldData } from '@v7/form/src/containers/BlockNoteRenderer/types';
import { setItem } from '@v7/form/src/utils/store';
import { ROUTE_TYPE } from '@v7/form/src/utils/constant';
import {
  updateCandidateDetails,
  updateFaceAuthDetails,
  updateFileUploadStatus,
  updateFormData,
  updateFormFileData,
  updateFormState,
} from '@v7/form/src/store/actions';
import { FormState, UpdateFormDataPayload } from '@v7/form/src/store/types';

const initialState: FormState = {
  formData: {},
  formFileData: {},
  formState: ROUTE_TYPE.BUILDER,
  candidateDetails: {},
  faceAuthDetails: {},
  fileUploadStatus: {},
};

const reducer = createReducer(initialState, (builder) => {
  builder.addCase(updateFormData, (state, action: PayloadAction<UpdateFormDataPayload>) => {
    state.formData = { ...state.formData, ...action.payload.fieldValues };
    setItem(action.payload.savedKey, state.formData); // store form data in localstorage
  });
  builder.addCase(updateFormFileData, (state, action: PayloadAction<FieldData>) => {
    state.formFileData = { ...state.formFileData, ...action.payload };
  });
  builder.addCase(updateFormState, (state, action) => {
    state.formState = action.payload;
  });
  builder.addCase(updateCandidateDetails, (state, action) => {
    state.candidateDetails = action.payload;
  });
  builder.addCase(updateFaceAuthDetails, (state, action) => {
    state.faceAuthDetails = { ...state.faceAuthDetails, ...(action.payload as FieldData) };
  });
  builder.addCase(updateFileUploadStatus, (state, action) => {
    state.fileUploadStatus = { ...state.fileUploadStatus, ...(action.payload as FieldData) };
  });
});

export default reducer;
